import { Component } from '@angular/core';

@Component({
  selector: 'my-factura',
  styles: [],
  templateUrl: 'factura.component.html'
})

export class FacturaComponent {}



// WEBPACK FOOTER //
// ./src/app/factura/factura.component.ts